import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import FormDialog from '../../../components/ui/FormDialog';
import { notify, getErrorMessage } from '../../../components/feedback/notify';

export default function AdicionarAdmin(props) {
    const token = localStorage.getItem('token');

    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setNome('');
        setEmail('');
        setSenha('');
        props.setAdicionarAdmin(false);
    };

    const handleSubmit = async () => {
        if (!nome || !email || !senha) {
            notify.warning("Preencha nome, e-mail e senha.");
            return;
        }
        try {
            setLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/adicionarAdmin`, {
                nome,
                email,
                senha,
            }, {
                headers: {
                    Authorization: token
                }
            });
            notify.success("Administrador adicionado com sucesso.");
            handleClose();
            props.onSaved?.();
        } catch (error) {
            console.error("Erro ao adicionar admin:", error);
            notify.error(getErrorMessage(error, "Não foi possível adicionar o administrador."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <FormDialog
            open={props.adicionarAdmin}
            onClose={handleClose}
            onSubmit={handleSubmit}
            title="Adicionar administrador"
            description="O novo administrador terá acesso completo a este painel."
            submitLabel="Adicionar"
            loading={loading}
        >
            <TextField
                autoFocus
                required
                label="Nome"
                placeholder="Nome completo"
                fullWidth
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                size="small"
                autoComplete="off"
            />
            <TextField
                required
                label="E-mail"
                autoComplete="off"
                placeholder="nome@contblack.com.br"
                type="email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="small"
            />
            <TextField
                required
                label="Senha"
                autoComplete="new-password"
                placeholder="Senha de acesso"
                type="password"
                fullWidth
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                size="small"
            />
        </FormDialog>
    );
}
